import { render, staticRenderFns } from "./assign-car.vue?vue&type=template&id=471e4e3c&scoped=true"
import script from "./assign-car.vue?vue&type=script&lang=js"
export * from "./assign-car.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471e4e3c",
  null
  
)

export default component.exports